import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('menu.userManagement'),
    icon: 'el-icon-user',
    children: [
      {
        title: i18n.t('model.user'),
        icon: 'el-icon-s-custom',
        route: { name: 'users.index' }
      },
      {
        title: i18n.t('model.member'),
        icon: 'el-icon-postcard',
        route: { name: 'members.index' }
      },
      {
        title: i18n.t('model.adminUsersRole'),
        icon: 'el-icon-user-solid',
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        icon: 'el-icon-view',
        route: { name: 'roles.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.productManagement'),
    icon: 'el-icon-goblet-square-full',
    children: [
      {
        title: i18n.t('model.product'),
        icon: 'el-icon-goblet-square-full',
        route: { name: 'products.index' }
      },
      {
        title: i18n.t('model.productCategory'),
        icon: 'el-icon-s-grid',
        route: { name: 'product_categories.index' }
      },
      {
        title: i18n.t('model.productRating'),
        icon: 'el-icon-star-off',
        route: { name: 'product_ratings.index' }
      }
    ]
  },
  {
    title: i18n.t('menu.merchantManagement'),
    icon: 'el-icon-s-shop',
    children: [
      {
        title: i18n.t('model.merchant'),
        icon: 'el-icon-s-shop',
        route: { name: 'merchants.index' }
      },
      {
        title: i18n.t('model.merchant'),
        icon: 'el-icon-s-shop',
        route: { name: 'merchants.show', params: { id: 'current' } },
        can: ['merchants.read_detail_menu']
      },
      {
        title: i18n.t('model.merchantCategory'),
        icon: 'el-icon-s-grid',
        route: { name: 'merchant_categories.index' }
      },
      {
        title: i18n.t('model.provenance'),
        icon: 'el-icon-map-location',
        route: { name: 'provenances.index' }
      }
    ]
  },
  {
    title: i18n.t('menu.eventManagement'),
    icon: 'el-icon-notebook-1',
    children: [
      {
        title: i18n.t('model.event'),
        icon: 'el-icon-notebook-1',
        route: { name: 'events.index' }
      },
      {
        title: i18n.t('model.eventBooking'),
        icon: 'el-icon-date',
        route: { name: 'event_bookings.index' }
      },
      {
        title: i18n.t('model.eventCategory'),
        icon: 'el-icon-s-grid',
        route: { name: 'event_categories.index' }
      }
    ]
  },
  {
    title: i18n.t('menu.contentManagement'),
    icon: 'el-icon-reading',
    children: [
      {
        title: i18n.t('model.activeStorageBlob'),
        icon: 'el-icon-upload',
        route: { name: 'blobs.index' }
      },
      {
        title: i18n.t('model.topic'),
        icon: 'el-icon-paperclip',
        route: { name: 'topics.index' },
      },
      {
        title: i18n.t('model.post'),
        icon: 'el-icon-s-opportunity',
        route: { name: 'posts.index' },
      },
      {
        title: i18n.t('model.question'),
        icon: 'el-icon-question',
        route: { name: 'questions.index' },
      },
      {
        title: i18n.t('model.message'),
        icon: 'el-icon-message-solid',
        route: { name: 'messages.index' },
      },
      {
        title: i18n.t('model.hotWord'),
        icon: 'el-icon-search',
        route: { name: 'hot_words.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.pageManagement'),
    icon: 'el-icon-s-management',
    children: [
      {
        title: i18n.t('model.customPage'),
        icon: 'el-icon-s-operation',
        route: { name: 'custom_pages.index' }
      },
      {
        title: i18n.t('model.page'),
        icon: 'el-icon-edit-outline',
        route: { name: 'pages.index' }
      },
      {
        title: i18n.t('model.banner'),
        icon: 'el-icon-picture-outline',
        route: { name: 'banners.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.applicationManagement'),
    icon: 'el-icon-setting',
    children: [
      {
        title: i18n.t('model.application'),
        icon: 'el-icon-menu',
        route: { name: 'applications.index' }
      },
      {
        title: i18n.t('model.application'),
        icon: 'el-icon-menu',
        route: { name: 'applications.show', params: { id: 'current' } },
        can: ['applications.read_detail_menu']
      },
      {
        title: i18n.t('model.tester'),
        route: { name: 'testers.index' },
        icon: 'el-icon-setting'
      }//,
      // {
        // title: '其他配置',
        // route: { name: 'app_configs.show' },
        // icon: 'el-icon-menu'
      // }
    ]
  },
  {
    title: '第三方平台管理',
    icon: 'el-icon-view',
    children: [
      {
        title: '小程序管理',
        icon: 'el-icon-menu',
        route: { name: 'wtpp_applications.index' }
      },
      {
        title: '草稿箱',
        icon: 'el-icon-view',
        route: { name: 'draft_templates.index' }
      },
      {
        title: '代码模板',
        icon: 'el-icon-view',
        route: { name: 'templates.index' }
      }
    ]
  },
  {
    title: i18n.t('menu.dataAnalysis'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
        icon: 'el-icon-s-custom',
        route: { name: 'user_portrait' },
        can: 'data_analyses.user_portrait'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitPage'),
        icon: 'el-icon-document-copy',
        route: { name: 'visit_page' },
        can: 'data_analyses.visit_page'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
        icon: 'el-icon-pie-chart',
        route: { name: 'visit_distribution' },
        can: 'data_analyses.visit_distribution'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
        icon: 'el-icon-s-data',
        route: { name: 'retain_info' },
        can: 'data_analyses.retain_info'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
        icon: 'el-icon-data-line',
        route: { name: 'visit_trend' },
        can: 'data_analyses.visit_trend'
      }
    ]
  },
  {
    title: '站点设置',
    icon: 'el-icon-view',
    route: { name: 'settings.show' },
    can: 'settings.read_menu'
  }
];
